import cntl from "cntl";
import PropTypes from "prop-types";
import { Tag } from "../molecules";
import { useTranslation } from "react-i18next";
import { KEYBOARDS, SIZE, WIDTH } from "../constants";

const propTypes = {
  onTags: PropTypes.func,
  label: PropTypes.string,
  initTags: PropTypes.array,
  isDisabled: PropTypes.bool,
  className: PropTypes.string,
  size: PropTypes.oneOf([SIZE.sm, SIZE.lg]),
  width: PropTypes.oneOf([WIDTH.xs, WIDTH.sm, WIDTH.md, WIDTH.lg, WIDTH.xl]),
};

function TagsInput({ label, initTags, size, width, onTags, className, isDisabled, ...props }) {
  const { t } = useTranslation();
  let tags = initTags || [];

  const settingsWrapper = {
    sm: {
      wrapper: {
        heigth: "min-h-[2.25rem]",
      },
      input: {
        heigth: "h-6",
      },
      fontStyle: "text-sm",
    },
    lg: {
      wrapper: {
        heigth: "min-h-[2.75rem]",
      },
      input: {
        heigth: "h-6",
      },
      fontStyle: "text-base",
    },
    default: {
      wrapper: {
        heigth: "min-h-[2.75rem]",
      },
      input: {
        heigth: "h-6",
      },
      fontStyle: "text-base",
    },
  };

  const wrapperCn = () => cntl`
    flex
    flex-col
    gap-y-1.5
    ${className ? className : undefined}
  `;

  const labelCn = () => cntl`
    text-sm
    font-medium
    text-grey-700
  `;

  const inputAndTagsCn = () => cntl`
    flex
    px-4
    py-2
    gap-1
    border
    flex-row
    flex-wrap
    shadow-sm
    rounded-lg
    items-center
    border-grey-300
    focus:ring-offset-0
    enabled:text-grey-900
    disabled:text-grey-500
    focus:ring-primary-100
    focus-within:ring-4
    focus-within:ring-primary-100
    focus-within:border-primary-300
    ${width || "w-full"}
    ${
      isDisabled
        ? cntl`focus:ring-0 bg-grey-50 focus:border-grey-300`
        : cntl`focus:ring-4 bg-white focus:border-primary-300`
    }
    ${settingsWrapper[size]?.fontStyle || settingsWrapper["default"]?.fontStyle}
    ${settingsWrapper[size]?.wrapper?.heigth || settingsWrapper["default"]?.wrapper?.heigth}
  `;

  const tagCn = () => cntl`
    z-10
  `;

  const inputCn = () => cntl`
    truncate
    focus:outline-0
    ${settingsWrapper[size]?.input?.heigth || settingsWrapper["default"]?.input?.heigth}
  `;

  const handleKeyDown = (e) => {
    const value = e.target.value;

    if (e.keyCode === KEYBOARDS.enter) {
      if (!value.trim()) {
        return;
      } else {
        if (!tags.includes(value)) {
          tags.push(value);
          onTags(tags);
          e.target.value = "";
        }
      }
    } else if (e.keyCode === KEYBOARDS.backspace) {
      if (!value.length && tags.length) {
        const newTagsArr = tags.splice(0, tags.length - 1);
        tags.push(newTagsArr);
        onTags(newTagsArr);
      }
    } else {
      return;
    }
  };

  const onRemoveTag = (label) => {
    onTags(tags?.filter((tag) => tag !== label));
  };

  return (
    <div className={wrapperCn()}>
      {!!label?.length && <label className={labelCn()}>{label}</label>}
      <div tabIndex={0} className={inputAndTagsCn()}>
        {tags?.map((label, index) => {
          return (
            <Tag
              label={label}
              size={SIZE.md}
              className={tagCn()}
              key={`tag-${index}`}
              onCloseProps={{
                isVisible: true,
                onClose: () => onRemoveTag(label),
              }}
            />
          );
        })}
        <input
          {...props}
          disabled={isDisabled}
          className={inputCn()}
          onKeyDown={handleKeyDown}
          placeholder={t("input.placeholder.tags")}
        />
      </div>
    </div>
  );
}

TagsInput.propTypes = propTypes;
export default TagsInput;
